import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-button-dropdown-example',
  templateUrl: './button-dropdown.component.html',
})
export class KitBootstrapButtonDropdownExampleComponent {}
